export default __webpack_public_path__ + "32920913e717bfa4aec53cb3f26d8e1c.svg";